import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import * as Api from 'api';

class PageSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pages: []
    }

    this.search = this.search.bind(this);
  }
  search(input, id) {
    this.setState({ searching: true });
    Api.fetchPages({
      _id: id,
      size: 50,
      filters: { title: { $regex: `${input}`, $options: 'gi' } }
    }).then(data => {
      if(!this.mounted) return;
      this.setState({
        searching: false,
        pages: data.results
      })
    }).catch(error => {
      if(!this.mounted) return;
      this.setState({
        searching: false,
        error
      });
    })
  }
  componentDidMount() {
    this.mounted = true;
    this.search('', this.props.value)
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    if(this.props.readOnly) {
      const page = this.state.pages.find(page => page._id == this.props.value);
      if(!page) return null;
      return <span>{page.title}</span>
    }
    return (
      <Select
        isLoading={this.state.searching}
        placeholder='Select a page'
        options={this.state.pages.map(page => ({ label: page.title, value: page._id }))}
        onInputChange={this.search}
        {...this.props}
      />
    );
  }
}

export default PageSelector;



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/page-selector.js